import React from 'react'
import BudgetVirtualCards from 'src/app/BudgetVirtualCards/BudgetVirtualCards'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { budgetVirtualCardsRouteProps } from 'src/navigation/routeProps'

const BudgetVirtualCardsAppRoute: AppRoute = {
  id: AppLocation.BudgetVirtualCards,
  routeProps: budgetVirtualCardsRouteProps,
  component: <BudgetVirtualCards />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default BudgetVirtualCardsAppRoute
